import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTableModule, MatTableDataSource } from '@angular/material/table'
import { NgIf } from '@angular/common'

// Fork enxuto de table-list-simple (shared/components/table-list) só com as colunas
// que a listagem de OS do Portal do Fornecedor precisa: período, valor, prazo de
// pagamento, observação e indicadores de motorista/veículo atribuídos.
@Component({
  selector: 'table-list-supplier-portal-os',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, MatTableModule, NgIf],
  templateUrl: './table-list-supplier-portal-os.component.html',
  styleUrl: './table-list-supplier-portal-os.component.scss',
})
export class TableListSupplierPortalOsComponent implements OnInit, OnChanges {
  @Input() dataSource: any[] = []
  @Input() columns: any[] = []

  @Output() viewItem = new EventEmitter<any>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  viewItemEvent(item: any): void {
    this.viewItem.emit(item)
  }

  // No portal do fornecedor não usamos "Operador" — pra ele é sempre o Consultor
  // Operacional que confirma/recusa, não faz sentido expor o nível hierárquico interno.
  formatStatus(descricaoStatus: string): string {
    return descricaoStatus === 'Aguardando Confirmação Operador'
      ? 'Aguardando Confirmação do Consultor Operacional'
      : descricaoStatus
  }

  formatCurrency(value: any): string {
    if (value == null) return '-'
    const n = typeof value === 'number' ? value : parseFloat(value)
    if (isNaN(n)) return '-'
    return `R$ ${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }

  formatTime(time: string | null | undefined): string {
    return time ? time.substring(0, 5) : '-'
  }

  displayValue(value: any): any {
    return value === null || value === undefined || value === '' ? '-' : value
  }
}
